import React, { useState, useEffect, useCallback } from "react";
import Navbar from "../../../components/Navbar/Navbar";
import { Breadcrumb, Button, Drawer, Select } from "antd";
import { DoubleRightOutlined, DownloadOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../../loading";
import "../../../../src/styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../../Routes";
import LoadingSpinner from "../../../components/Loading";

import dayjs from "dayjs";
import i18next from "i18next";
import { toast } from "react-toastify";
import InventorySaleSummaryTable from "./InventorySaleSummartTable";
import DateFilter from "../../../components/ui/DateFilter";
import { URLS } from "../../../API/API endpoints";
import axiosInstance from "../../../AxiosInstance";
import ExportCasInOutReportModal from "../../SessionHistory/ExportCasInOutReportModal";
import { GetPaymentMethods } from "../../../API  Functions/CashierSetup";
import moment from "moment";
import { checkPermission } from "../../../Utils/permissionHelper";
import SearchBox from "../../../components/CustomWidgets/SearchBox";

const debounce = (func, delay) => {
  let timer;
  return function (...args) {
    const context = this;
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(context, args), delay);
  };
};

const InventorySaleSummary = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const [loading, setloading] = useState(false);
  const { Option } = Select;
  const [currentLimit, setCurrentLimit] = useState(10); // Default limit
  const [currentOffset, setCurrentOffset] = useState(0); // Default offset
  const [selectedRange, setSelectedRange] = useState("thisMonth");
  const [saleSummary, setSaleSummary] = useState([]);
  const today = dayjs();
  const formatToday = today.format("YYYY-MM-DD");
  const startofMonth = today.startOf("month").format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(startofMonth);
  const [endDate, setEndDate] = useState(formatToday);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [allMethods, setAllMethods] = useState([]);
  const [allcategory, setAllCategory] = useState([]);
  const [allSubcategory, setAllSubCategory] = useState([]);
  const [searchByShortCode, setSearchByShortCode] = useState(false);
  const [query, setquery] = useState("");

  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);

  useEffect(() => {
    // if (user_id) {
    GetMethods();
    // GetCategory();
    GetInventorySaleSummary(
      query,
      selectedCategory,
      selectedSubcategory,
      selectedPaymentMethod,
      startDate,
      endDate,
      currentOffset,
      currentLimit,
    );
    // }
  }, [currentLimit, currentOffset]);

  const GetMethods = async () => {
    try {
      const res1 = await GetPaymentMethods({ user_id: user_id });
      if (res1?.result[0].status_code == 200) {
        setAllMethods(res1?.result[0].response);
      } else {
        setAllMethods([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setloading(false);
    }
  };

  const GetCategory = async () => {
    try {
      // setloading(true);
      const response = await axiosInstance.post(URLS.GET_PARENT_CATEGORY, {
        store_id: company_id,
        lang: i18n.language == "ar" ? "ar_001" : "en_US",
      });
      if (response?.data?.result?.status_code === 200) {
        setAllCategory(response?.data?.result?.data);
      } else {
        setAllCategory([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setloading(false);
    } finally {
      setloading(false);
    }
  };

  const GetSubCategory = async (id) => {
    try {
      // setloading(true);
      const response = await axiosInstance.post(URLS.GET_SUB_CATEGORY, {
        store_id: company_id,
        parent_categ_id: id,
        lang: i18n.language == "ar" ? "ar_001" : "en_US",
        search: "",
      });
      if (response?.data?.result?.status_code === 200) {
        setAllSubCategory(response?.data?.result?.data);
      } else {
        setAllSubCategory([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setloading(false);
    } finally {
      setloading(false);
    }
  };

  const GetInventorySaleSummary = async (
    text,
    cat,
    subCat,
    method,
    start,
    end,
    offset,
    limit,
  ) => {
    try {
      // setloading(true);
      console.log("search==>", searchByShortCode);
      const response = await axiosInstance.post(URLS.INVENTORY_SALE_SUMMARY, {
        search: searchByShortCode ? "" : text,
        short_code: searchByShortCode ? text : "",
        company_id: company_id,
        offset: offset,
        limit: limit,
        start_date: start,
        end_date: end,
        // category_id: cat, //optional
        // sub_category_id: subCat, //optional
        payment_method: method, //optional
        lang: i18n.language == "ar" ? "ar_001" : "en_US",
      });
      if (response?.data?.result?.status_code === 200) {
        setSaleSummary(response?.data?.result?.data);
      } else {
        setSaleSummary([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setloading(false);
    } finally {
      setloading(false);
    }
  };

  const handleExport = async (dates) => {
    let payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      start_date: dates?.startDate,
      end_date: dates?.endDate,
      company_id: company_id,
    };
    const response = await axiosInstance.post(
      URLS.INVENTORY_SALE_SUMMARY_EXCEL,
      payload,
    );
    console.log("handleExport", response);
    if (response?.data?.result?.status_code == 200) {
      setExportModalOpen(false);
      downloadFile(response?.data?.result?.file_base64);
    } else {
      toast.error(response?.data?.result.status);
    }
  };

  const downloadFile = (base64Data) => {
    try {
      if (
        !base64Data ||
        typeof base64Data !== "string" ||
        base64Data.trim() === ""
      ) {
        alert("No valid file data available for download");
        return;
      }

      let cleanBase64 = base64Data
        .trim()
        .replace(/^data:[\w/+-]+;base64,/, "")
        .replace(/^["']|["']$/g, "")
        .replace(/\s/g, "");

      const padLength = 4 - (cleanBase64.length % 4);
      if (padLength < 4) cleanBase64 += "=".repeat(padLength);

      let binaryString = atob(cleanBase64);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const header = new Uint8Array(bytes.buffer, 0, 8);
      let mimeType = "application/octet-stream";
      let fileExtension = "bin";

      if (header[0] === 0x50 && header[1] === 0x4b) {
        mimeType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        fileExtension = "xlsx";
      } else if (
        header[0] === 0xd0 &&
        header[1] === 0xcf &&
        header[2] === 0x11 &&
        header[3] === 0xe0
      ) {
        mimeType = "application/vnd.ms-excel";
        fileExtension = "xls";
      } else if (new TextDecoder().decode(header).includes(",")) {
        mimeType = "text/csv";
        fileExtension = "csv";
      }

      const blob = new Blob([bytes], { type: mimeType });
      // const timestamp = new Date()
      //   .toISOString()
      //   .replace(/[:.]/g, "-")
      //   .replace("T", "_")
      //   .slice(0, 19);
      // const filename = `inventory_sale_summary_${timestamp}.${fileExtension}`;
      const timestamp = moment().format("YYYY-MM-DD_HH.mm.ss"); // Using period for time
      const filename = `${t(
        "inventory_sale_summary",
      )}_${timestamp}.${fileExtension}`;

      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("File download failed:", error);
      alert(`Download failed: ${error.message || "Unknown error"}`);
    }
  };

  const handleMethodOptionChange = (id, selectedValue) => {
    console.log("selectedValue===>", selectedValue, id);

    setloading(true);
    if (id) {
      setSelectedPaymentMethod(selectedValue?.children);
      if (selectedValue?.children) {
        GetInventorySaleSummary(
          query,
          selectedCategory,
          selectedSubcategory,
          selectedValue?.children,
          startDate,
          endDate,
        );
      }
    } else {
      setSelectedPaymentMethod(null); // Reset selected category
      GetInventorySaleSummary(
        query,
        selectedCategory,
        selectedSubcategory,
        null,
        startDate,
        endDate,
        0,
        10,
      ); // Fetch all products
    }
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      GetInventorySaleSummary(value, null, null, "", startDate, endDate, 0, 10);
    }, 1000),
    [searchByShortCode, startDate, endDate],
  );

  const handleCategoryOptionChange = (id, selectedValue) => {
    setloading(true);
    if (id) {
      setSelectedCategory(id);
      GetSubCategory(id);
      if (id) {
        GetInventorySaleSummary(
          "",
          id,
          null,
          selectedPaymentMethod,
          startDate,
          endDate,
        );
      }
    } else {
      setSelectedSubcategory(null);
      setAllSubCategory([]);
      setSelectedCategory(null); // Reset selected category
      GetInventorySaleSummary(
        "",
        "",
        null,
        selectedPaymentMethod,
        startDate,
        endDate,
        0,
        10,
      ); // Fetch all products
    }
  };

  const handleSubCategoryOptionChange = (id, selectedValue) => {
    setloading(true);
    if (id) {
      setSelectedSubcategory(id);
      if (id) {
        GetInventorySaleSummary(
          "",
          selectedCategory,
          id,
          selectedPaymentMethod,
          startDate,
          endDate,
        );
      }
    } else {
      setSelectedSubcategory(null); // Reset selected category
      GetInventorySaleSummary(
        "",
        selectedCategory,
        null,
        selectedPaymentMethod,
        startDate,
        endDate,
        0,
        10,
      ); // Fetch all products
    }
  };

  return (
    <>
      <div className="flex w-full flex-col overflow-y-auto bg-[#F6F7F9] pb-2 md:h-full">
        <Navbar heading="Inventory Sale Summary" />
        <div className="custom-scrollbar ms-1 flex-grow overflow-y-auto overflow-hidden sm:ms-3">
          {/* <div className="font-extrabold mb-3">
            <Breadcrumb
              separator={<DoubleRightOutlined />}
              items={[
                {
                  title: <Link to={routes.purchase}>{t("inventory")}</Link>,
                  key: "purchase",
                },
                { title: t("Inventory Sale Summary") },
              ]}
              className="relative mt-3 font-semibold"
            />
          </div> */}

          <div className="mt-3">
            <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
              <div className="flex flex-col gap-2 md:flex-row md:items-end md:gap-x-2">
                <div className="flex w-full flex-row items-center gap-2 sm:w-auto">
                  <div className="min-w-0 flex-1 md:w-full">
                    <SearchBox
                      value={query}
                      // showBarcode={true}
                      searchResult={(values) => {
                        setquery(values);
                        setloading(true);
                        // setStartDate();
                        // setEndDate(end);
                        setSelectedCategory(null);
                        setSelectedSubcategory(null);
                        setSelectedPaymentMethod("");
                        debouncedSearch(values);
                      }}
                      placeholder={t("search_product")}
                    />
                  </div>

                  <button
                    type="button"
                    onClick={() => {
                      setSearchByShortCode(!searchByShortCode);
                    }}
                    className={`h-[40px] rounded-md border px-2 text-sm whitespace-nowrap ${
                      searchByShortCode
                        ? "bg-blue-100 border-primaryBlue text-primaryBlue"
                        : "bg-white border-gray-300 text-gray-700"
                    }`}
                  >
                    {t("Search Code")}
                  </button>
                </div>
                <DateFilter
                  setSelectedRange={setSelectedRange}
                  selectedRange={selectedRange}
                  SubmitFilter={(start, end) => {
                    setloading(true);
                    setStartDate(start);
                    setEndDate(end);
                    setSelectedCategory(null);
                    setSelectedSubcategory(null);
                    setSelectedPaymentMethod("");
                    setCurrentLimit(10);
                    setCurrentOffset(0);
                    setquery("");
                    GetInventorySaleSummary(
                      "",
                      null,
                      null,
                      "",
                      start,
                      end,
                      0,
                      10,
                    ); // Fetch all products
                  }}
                />
              </div>

              <div className="mx-1 mt-1 flex justify-end md:mx-8 md:mt-3">
                <button
                  className="flex h-10 w-full items-center justify-center gap-2 rounded-lg bg-primaryBlue text-sm font-semibold text-white sm:w-48"
                  // onClick={() => setExportModalOpen(true)}
                  onClick={() => {
                    if (checkPermission("/inventory/inventorysalesummary")) {
                      setExportModalOpen(true);
                    }
                  }}
                >
                  <DownloadOutlined
                    style={{ fontSize: "1.5em", MozMarginStart: -10 }}
                  />

                  <span>{t("Download in Excel")}</span>
                </button>
              </div>
            </div>

            {loading ? (
              <ShimmerLoader />
            ) : (
              <>
                <InventorySaleSummaryTable
                  additionalData={saleSummary}
                  pagination={(values) => {
                    // setloading(true);
                    console.log("values=---------->", values);

                    setCurrentLimit(values.limit);
                    setCurrentOffset(values.offset);
                  }}
                />
              </>
            )}
          </div>
        </div>
      </div>

      {exportModalOpen && (
        <ExportCasInOutReportModal
          heading={t("Download Inventory Sale Summary")}
          isOpen={exportModalOpen}
          onClose={() => setExportModalOpen(false)}
          onExport={(dates) => handleExport(dates)}
        />
      )}
    </>
  );
};

export default InventorySaleSummary;
